import React from 'react';
import styles from './TabsComponent.module.scss';
import CertificateViewerModal from '../../ui/CertificateViewerModal/CertificateViewerModal';
import TruncatedHtmlContent from '../../ui/TruncatedHtmlContent/TruncatedHtmlContent';
import mortarBoard from "../../../assets/images/ImgDetails/mortarBoard.png";
import { useTabsComponent } from './hooks/useTabsComponent';
import { StudyCard } from '../StudyCard/StudyCard';
import { TabsComponentProps } from './types';

const TabsComponent: React.FC<TabsComponentProps> = ({
    professionalInfo,
    studies,
    educationDefaultText,
}) => {
    const {
        t,
        viewerOpen,
        selectedCert,
        handleOpenViewer,
        handleCloseViewer
    } = useTabsComponent();

    const [openStudyUid, setOpenStudyUid] = React.useState<string | null>(null);

    return (
        <>
            <section className={styles['tab-system__section']}>
                <h2 className={styles['tab-system__section-title']}>
                    {t('landing.TabsComponent.trainingAndExperience', 'Formación y experiencia')}
                </h2>
                <div className={styles['tab-system__copy']}>
                    <TruncatedHtmlContent
                        htmlContent={professionalInfo?.replace(/<[^>]*>?/gm, '').trim()
                            ? professionalInfo
                            : (educationDefaultText || t('appAdmin.EditTabsComponent.professionalInfoPlaceholder'))}
                        maxLength={1000}
                    />
                </div>
            </section>
            
            <section className={styles['tab-system__section']}>
                <div className={styles['tab-system__section-head']}>
                    <h2 className={styles['tab-system__section-title']}>
                        {t('landing.TabsComponent.studiesTitle', 'Estudios y certificaciones')}
                    </h2>
                    <p className={styles['tab-system__section-subtitle']}>
                        {t('landing.TabsComponent.studiesSubtitle', 'Formación académica, cursos y certificaciones que respaldan el recorrido profesional.')}
                    </p>
                </div>
                <div className={styles['tab-system__studies-list']}>
                    {studies && studies.length > 0 ? (
                        studies.map((study, index) => {
                            const studyId = study.uid || String(index);
                            return study.is_validated && (
                                <StudyCard
                                    key={studyId}
                                    study={study}
                                    onViewCertificate={handleOpenViewer}
                                    isOpen={openStudyUid === studyId}
                                    onToggle={() => setOpenStudyUid(prev => prev === studyId ? null : studyId)}
                                />
                            );
                        })
                    ) : (
                        <div className={styles['tab-system__empty']}>
                            {t('landing.TabsComponent.noStudies', 'No se han agregado estudios')}
                        </div>
                    )}
                </div>
            </section>

            <CertificateViewerModal
                open={viewerOpen}
                onClose={handleCloseViewer}
                fileUrl={selectedCert.url}
                fileName={selectedCert.name}
                fileType={selectedCert.type}
            />
        </>
    );
};

export default TabsComponent;